module.exports = __webpack_public_path__ + "static/gift-9fc693361c47473882cc993253970abc.jpg";